import { database } from '../firebase/firebase';
import { ref, push } from 'firebase/database';

export const systemEventService = {
  // Logger un événement système
  logSystemEvent: async (eventData) => {
    try {
      const eventsRef = ref(database, 'systemEvents');
      await push(eventsRef, {
        ...eventData,
        event_timestamp: Date.now()
      });
    } catch (error) {
      console.error("Error logging system event:", error);
      throw error;
    }
  }
};